import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio, X, Play } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "@/lib/api";
import { useRef } from "react";

export default function NowPlayingBanner() {
  const navigate = useNavigate();
  const [parties, setParties] = useState([]);
  const [dismissed, setDismissed] = useState({});
  const seen = useRef(new Set());
  const audioCtxRef = useRef(null);

  const chime = () => {
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      if (!audioCtxRef.current) audioCtxRef.current = new Ctx();
      const ctx = audioCtxRef.current;
      if (ctx.state === "suspended") ctx.resume();
      const now = ctx.currentTime;
      [523.25, 783.99].forEach((f, i) => {
        const osc = ctx.createOscillator(); const g = ctx.createGain();
        osc.type = "sine"; osc.frequency.value = f;
        const s = now + i * 0.13;
        g.gain.setValueAtTime(0.0001, s);
        g.gain.exponentialRampToValueAtTime(0.07, s + 0.03);
        g.gain.exponentialRampToValueAtTime(0.0001, s + 0.3);
        osc.connect(g); g.connect(ctx.destination); osc.start(s); osc.stop(s + 0.35);
      });
    } catch {}
  };

  useEffect(() => {
    const load = () => api.get("/parties/following").then(({ data }) => {
      let isNew = false;
      data.forEach((p) => { if (!seen.current.has(p.id)) { seen.current.add(p.id); isNew = true; } });
      if (isNew && data.length) chime();
      setParties(data);
    }).catch(() => {});
    load();
    const i = setInterval(load, 15000);
    return () => clearInterval(i);
  }, []);

  const active = parties.filter((p) => !dismissed[p.id]);
  const p = active[0];

  return (
    <AnimatePresence>
      {p && (
        <motion.div initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-4" data-testid="now-playing-banner">
          <div className="flex items-center gap-3 rounded-2xl px-4 py-3 bg-gradient-to-r from-red-500/15 via-[#181824] to-[#181824] border border-red-500/30">
            <span className="relative flex h-2.5 w-2.5 shrink-0"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" /></span>
            <p className="text-sm min-w-0 flex-1 truncate">
              <b className="text-white">{p.host?.artist_name}</b> <span className="text-zinc-400">is live with</span> <span className="text-emerald-400">{p.track?.title}</span>
            </p>
            <button onClick={() => navigate(`/party/${p.id}`)} data-testid="banner-join-btn"
              className="flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-black font-bold text-xs transition-colors shrink-0">
              <Play className="w-3.5 h-3.5" /> Join
            </button>
            <button onClick={() => setDismissed((d) => ({ ...d, [p.id]: true }))} data-testid="banner-dismiss-btn"
              className="text-zinc-500 hover:text-white shrink-0"><X className="w-4 h-4" /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
